/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { PaymentState } from './PaymentState';
import {
    PaymentStateFromJSON,
    PaymentStateFromJSONTyped,
    PaymentStateToJSON,
    PaymentStateToJSONTyped,
} from './PaymentState';

/**
 * 
 * @export
 * @interface ClientPaymentDto
 */
export interface ClientPaymentDto {
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    commissionAmount: string;
    /**
     * 
     * @type {Currency}
     * @memberof ClientPaymentDto
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof ClientPaymentDto
     */
    executingLocationId: number;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    grossAmount: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    grossAmountAfterAddingTerminalTip: string;
    /**
     * 
     * @type {ClientPaymentDtoLatestEventCodeEnum}
     * @memberof ClientPaymentDto
     */
    latestEventCode: ClientPaymentDtoLatestEventCodeEnum;
    /**
     * 
     * @type {PaymentState}
     * @memberof ClientPaymentDto
     */
    latestState: PaymentState;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    netAmount: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    orderReference: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    paymentFeeAmount: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof ClientPaymentDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    paymentReference: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    paymentSplitStatuses: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    pendingRefundAmount: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    refundableAmount: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    refundedAmount: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    refundedAndPendingRefundAmount: string;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    terminalTipAmount: string;
    /**
     * 
     * @type {Date}
     * @memberof ClientPaymentDto
     */
    created?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPaymentDto
     */
    pspReference?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ClientPaymentDto
     */
    updated?: Date | null;
}


/**
 * @export
 */
export const ClientPaymentDtoLatestEventCodeEnum = {
    INITIATE: 'INITIATE',
    INITIATE_FAILED: 'INITIATE_FAILED',
    SEND_FOR_PAYMENT: 'SEND_FOR_PAYMENT',
    REDIRECT_SHOPPER: 'REDIRECT_SHOPPER',
    PAYMENT_CANCELLED: 'PAYMENT_CANCELLED',
    COMPLETE_WITHOUT_PAYMENT: 'COMPLETE_WITHOUT_PAYMENT',
    AUTHORISE: 'AUTHORISE',
    AUTHORISE_FAILED: 'AUTHORISE_FAILED',
    AUTHORISE_SUCCEEDED: 'AUTHORISE_SUCCEEDED',
    CAPTURE: 'CAPTURE',
    CAPTURE_SUCCEEDED: 'CAPTURE_SUCCEEDED',
    CAPTURE_FAILED: 'CAPTURE_FAILED',
    REFUND: 'REFUND',
    REFUND_SUCCEEDED: 'REFUND_SUCCEEDED',
    REFUND_FAILED: 'REFUND_FAILED',
    STATE_UNDETERMINED: 'STATE_UNDETERMINED',
    STATE_IN_PROGRESS: 'STATE_IN_PROGRESS',
    MANUAL_STATE_OVERRIDE: 'MANUAL_STATE_OVERRIDE'
} as const;
export type ClientPaymentDtoLatestEventCodeEnum = typeof ClientPaymentDtoLatestEventCodeEnum[keyof typeof ClientPaymentDtoLatestEventCodeEnum];


/**
 * Check if a given object implements the ClientPaymentDto interface.
 */
export function instanceOfClientPaymentDto(value: object): value is ClientPaymentDto {
    if (!('commissionAmount' in value) || value['commissionAmount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('executingLocationId' in value) || value['executingLocationId'] === undefined) return false;
    if (!('grossAmount' in value) || value['grossAmount'] === undefined) return false;
    if (!('grossAmountAfterAddingTerminalTip' in value) || value['grossAmountAfterAddingTerminalTip'] === undefined) return false;
    if (!('latestEventCode' in value) || value['latestEventCode'] === undefined) return false;
    if (!('latestState' in value) || value['latestState'] === undefined) return false;
    if (!('netAmount' in value) || value['netAmount'] === undefined) return false;
    if (!('orderReference' in value) || value['orderReference'] === undefined) return false;
    if (!('paymentFeeAmount' in value) || value['paymentFeeAmount'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('paymentSplitStatuses' in value) || value['paymentSplitStatuses'] === undefined) return false;
    if (!('pendingRefundAmount' in value) || value['pendingRefundAmount'] === undefined) return false;
    if (!('refundableAmount' in value) || value['refundableAmount'] === undefined) return false;
    if (!('refundedAmount' in value) || value['refundedAmount'] === undefined) return false;
    if (!('refundedAndPendingRefundAmount' in value) || value['refundedAndPendingRefundAmount'] === undefined) return false;
    if (!('terminalTipAmount' in value) || value['terminalTipAmount'] === undefined) return false;
    return true;
}

export function ClientPaymentDtoFromJSON(json: any): ClientPaymentDto {
    return ClientPaymentDtoFromJSONTyped(json, false);
}

export function ClientPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientPaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'commissionAmount': json['commissionAmount'],
        'currency': CurrencyFromJSON(json['currency']),
        'executingLocationId': json['executingLocationId'],
        'grossAmount': json['grossAmount'],
        'grossAmountAfterAddingTerminalTip': json['grossAmountAfterAddingTerminalTip'],
        'latestEventCode': json['latestEventCode'],
        'latestState': PaymentStateFromJSON(json['latestState']),
        'netAmount': json['netAmount'],
        'orderReference': json['orderReference'],
        'paymentFeeAmount': json['paymentFeeAmount'],
        'paymentMethod': json['paymentMethod'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentReference': json['paymentReference'],
        'paymentSplitStatuses': json['paymentSplitStatuses'],
        'pendingRefundAmount': json['pendingRefundAmount'],
        'refundableAmount': json['refundableAmount'],
        'refundedAmount': json['refundedAmount'],
        'refundedAndPendingRefundAmount': json['refundedAndPendingRefundAmount'],
        'terminalTipAmount': json['terminalTipAmount'],
        'created': json['created'] === undefined ? undefined : json['created'] === null ? null : (new Date(json['created'])),
        'pspReference': json['pspReference'] === undefined ? undefined : json['pspReference'] === null ? null : json['pspReference'],
        'updated': json['updated'] === undefined ? undefined : json['updated'] === null ? null : (new Date(json['updated'])),
    };
}

export function ClientPaymentDtoToJSON(json: any): ClientPaymentDto {
    return ClientPaymentDtoToJSONTyped(json, false);
}

export function ClientPaymentDtoToJSONTyped(value?: ClientPaymentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'commissionAmount': value['commissionAmount'],
        'currency': CurrencyToJSON(value['currency']),
        'executingLocationId': value['executingLocationId'],
        'grossAmount': value['grossAmount'],
        'grossAmountAfterAddingTerminalTip': value['grossAmountAfterAddingTerminalTip'],
        'latestEventCode': value['latestEventCode'],
        'latestState': PaymentStateToJSON(value['latestState']),
        'netAmount': value['netAmount'],
        'orderReference': value['orderReference'],
        'paymentFeeAmount': value['paymentFeeAmount'],
        'paymentMethod': value['paymentMethod'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentReference': value['paymentReference'],
        'paymentSplitStatuses': value['paymentSplitStatuses'],
        'pendingRefundAmount': value['pendingRefundAmount'],
        'refundableAmount': value['refundableAmount'],
        'refundedAmount': value['refundedAmount'],
        'refundedAndPendingRefundAmount': value['refundedAndPendingRefundAmount'],
        'terminalTipAmount': value['terminalTipAmount'],
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
        'pspReference': value['pspReference'],
        'updated': value['updated'] == null ? value['updated'] : value['updated'].toISOString(),
    };
}

